 
import { useT } from './contexts/LocalizationContext'
import { Translations } from './Translations'
import { LangSaveType, LocalizationModel, localizationSettings } from './utils/localization'

localizationSettings.default = 'cs'
localizationSettings.langs = ['cs', 'sk', 'en']
localizationSettings.type = LangSaveType.url

export const localizationModel: LocalizationModel = {
  cs: require('./translations/cs.json'),
  sk: require('./translations/sk.json'),
  en: require('./translations/en.json')
}

export const useAppT = () => useT<Translations>()

